import * as React from 'react';
import { CodeResendStatus } from './CodeResendStatus';
import { Spinner, Text } from '@origin-digital/style-guide';
import { MouseEvent } from 'react';
import { UndecoratedLink } from 'ts/components/UndecoratedLink';

interface ResendViewProps {
  codeResendStatus: CodeResendStatus;
  onResendClicked: (event: MouseEvent<HTMLAnchorElement>) => void;
}

const ResendCodeView: React.FC<ResendViewProps> = ({ codeResendStatus, onResendClicked }) => {
  switch (codeResendStatus) {
    case CodeResendStatus.Initial:
    case CodeResendStatus.Failed:
      return (
        <UndecoratedLink
          color="red"
          data-id="resend-button"
          href="#"
          onClick={onResendClicked}
          text="No code? Let's resend it"
        />
      );
    case CodeResendStatus.Sending:
      return <Spinner data-id="resend-spinner" show={true} />;
    case CodeResendStatus.Sent:
      return (
        <Text
          size="sm"
          fontWeight="regular"
          color="green"
          overflow="normal"
          data-id="onetimecode-resent"
        >
          Sent
        </Text>
      );
  }
};

export { ResendCodeView };
